


























import { NewsRenderModel, TextContent, Languages } from "@/services/news/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class TextRender extends Vue {
    @Prop() private news!: NewsRenderModel;
    @Prop() private active!: boolean;

    reload = false;
    reloadComponent = 0;
    languages = Languages;

    // lifecycle hooks
    created() {
    }

    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0 && this.renderModel.duration) {
            return setTimeout(
                this.setNextNews,
                this.renderModel.duration * 1000
            );
        }
    }

    get renderModel(): TextContent {
        return this.news.content as TextContent;
    }

    get date() {
        const lang = this.languages.find(x => x.text === this.renderModel.language.toLowerCase());
        const locale = lang ? lang.code.toLowerCase() : "en";
        const date = moment(this.news.publishDate);
        date.locale(locale);
        return date.format("MMMM Do YYYY");
    }

    setNextNews() {
        this.$emit("setNextNews");
    }

    navigateTo(url: string) {
        window.open(url);
    }
}
